<template>
  <ion-item lines="none">
    <div class="flex_column_container">
      <ion-text color="dark"><h3 class="ion-no-margin title">{{ title }}</h3></ion-text>
      <ion-text color="medium">
        <small>{{ description }}</small>
      </ion-text>
    </div>
  </ion-item>
</template>

<script lang="ts" setup>
import {
  IonItem,
  IonText
} from '@ionic/vue';
import {defineProps} from "vue";

defineProps<{
  title: string
  description: string
}>()
</script>

<style scoped>

</style>